import http from "../../http-common";
/* eslint-disable */
class SejarahService {
  sejarah() {
    return http.get("/sejarah", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("description", data.description);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/sejarah", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("description", data.description);
    if (data.poster_url != null) bodyFormData.append("photo", data.poster_url);

    return http.put(`/sejarah/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new SejarahService();
